import React from 'react'
import { Helmet } from 'react-helmet'

import { About, Contacts, Education, Experience, Footer, Landing, Navbar, Projects, Services, Skills } from '../../components'
import { headerData } from '../../data/headerData'

function HomePage() {
    
    return (
        <div>
            <Helmet>
                <title>{headerData.name} - Portfolio</title>
            </Helmet>
            
            <Navbar />
            <Landing />
            <About />
            <Education />
            <Skills />
            <Experience />
            <Projects />
            <Services />
            {/* <Blog /> */}
            <Contacts />
            <Footer />
        </div>
    )
}

export default HomePage
